import { watch } from "vue";

import { toggleActions } from "@/action/toggleActions";
import { useClientSettingsStore } from "@/store/clientSettings";
import { useToastStore } from "@/store/toast";

/**
 * This composable tracks if the auto-input-device detection is working correctly.
 * If not, it will prompt the user to select their input device manually.
 */
export function useEffectiveInputSafety() {
  let switchCount = 0;

  // Track how often the effective input device is updated
  watch(
    () => useClientSettingsStore().effectiveInputDevice,
    (newValue, oldValue) => {
      if (newValue !== oldValue) {
        switchCount++;
      }

      checkEffectiveInputDeviceFlipFlop(switchCount);
    },
  );

  /**
   * Check if we're having issues determining the effective input device
   * (assumed when the user's device switches between mouse and trackpad
   * more than 20 times in a single session).
   * If so, show a toast to the user, prompting them to select their input device manually.
   *
   * This will just be shown once per user (if they interact with the toast).
   */
  function checkEffectiveInputDeviceFlipFlop(count: number) {
    if (count > 20) {
      const setInputDeviceButton = {
        labelKey: /*$t*/ "settings.effectiveInputWarning.button",
        onClick: () => {
          // Hide the toast and open the settings modal
          useToastStore().hide(true);
          toggleActions.showSettings("toast");

          // Scroll to the Input Device section
          setTimeout(() => {
            const settingsSection = document.querySelector("#settings-input-device-title");
            settingsSection?.scrollIntoView({ behavior: "smooth" });
          }, 100);
        },
      };

      useToastStore().show(/*$t*/ "settings.effectiveInputWarning", {
        level: "warn",
        duration: 0,
        closeable: true,
        iconSize: "50",
        buttons: [setInputDeviceButton],
      });
    }
  }
}
